import { render, staticRenderFns } from "./SiteTable.vue?vue&type=template&id=20e07a1c&scoped=true"
import script from "./SiteTable.vue?vue&type=script&lang=js"
export * from "./SiteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e07a1c",
  null
  
)

export default component.exports